module.exports = __webpack_public_path__ + "static/img/logo.a1be07c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 1